<template>
  <div class="similary-goods">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box flex-3">
          <div class="search-wrap">
            <label class="label">筛选内容</label>
            <div class="block fleft margin-right">
              <label class="label inline-block">动态状态</label>
              <label class="inline-block">
                <input type="checkbox" value="1" name='status' v-model="search.status">已放行
              </label>
              <label class="inline-block">
                <input type="checkbox" value="0" name='status' v-model="search.status">待放行
              </label>
              <label class="inline-block">
                <input type="checkbox" value="3" name='status' v-model="search.status">回收站
              </label>
            </div>
            <div class="block fleft margin-right">
              <label class="label inline-block">商品ID</label>
              <input type="number" v-model.number="search.thirdPartyGoodsId">
            </div>
            <div class="block fleft margin-right">
              <label class="label inline-block">动态ID</label>
              <input type="number" v-model.number="search.articleId">
            </div>
            <div class="block fleft margin-right">
              <label class="label inline-block">价格区间</label>
              <input type="number" v-model.number="search.startPrice">～
              <input type="number" v-model.number="search.endPrice">
            </div>
            <div class="block fleft margin-right">
              <label class="label inline-block">前端状态</label>
              <el-select v-model="search.showStatus" filterable placeholder="请选择">
                <el-option
                        v-for="item in initShowStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="block fleft margin-right">
              <label class="label inline-block">入库状态</label>
              <el-select v-model="search.thirdStatus" filterable placeholder="请选择">
                <el-option
                        v-for="item in initThirdStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="control">
              <label class="label inline-block r-top">放行时间</label>
              <span class="inline-block">
                <el-date-picker
                  v-model="search.startTime"
                  type="datetime"
                  placeholder="放行开始时间"
                  align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                  v-model="search.endTime"
                  type="datetime"
                  placeholder="放行结束时间"
                  align="right">
                </el-date-picker>
              </span>
            </div>
            <div class="control">
              <button class="button is-info" @click="doSearch">搜索</button>
            </div>
          </div>
        </article>
        <div class="flex-space"></div>
        <article class="tile is-child box flex-1" >
          <label class="label">数据</label>
          <div class="data-wrap">
            <div class="data-item">
              <label class="label">本日抓取商品数</label>
              <label class="label">{{todayData.todayGoodsCatched}}</label>
            </div>
            <div class="data-item">
              <label class="label">本日已上架商品数</label>
              <label class="label">{{todayData.todayGoodsOnline}}</label>
            </div>
            <div class="data-item">
              <label class="label">总抓取商品数</label>
              <label class="label">{{todayData.goodsCatched}}</label>
            </div>
            <div class="data-item">
              <label class="label">总上架商品数</label>
              <label class="label">{{todayData.goodsOnline}}</label>
            </div>
          </div>
        </article>
      </div>
      <div class="clearfix">
        <button class="button is-info margin-left" @click="onChangeStatus(1)">上架选中商品</button>
        <button class="button is-danger margin-left" @click="onChangeStatus(2)" >删除选中商品</button>
        <router-link class="button is-info margin-left" :to="{name:'catchPriceSetting'}" >抓取价格设置</router-link>
        <el-pagination
          v-if="count > 0"
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>
                <input type="checkbox" v-model="isCheckAll" @click="onCheckAll">
              </th>
              <th>商品ID</th>
              <th>原图</th>
              <th>切图</th>
              <th>商品</th>
              <th>创建时间</th>
              <th>更新时间</th>
              <th>库存</th>
              <th>类目</th>
              <th style="min-width: 60px;">价格</th>
              <th>状态</th>
              <th><span class="sort" @click="onSort">点击数<i class="fa" :class="sort.class" aria-hidden="true"></i></span></th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in list" :data-id="item.id">
              <td>
                <label class="checkbox-panel"><input type="checkbox" v-model="item.checked" @click="onCheckOne(index)"></label>
              </td>
              <td>{{item.goodsId}}</td>
              <td class="lightgallery" @click="onImagePreviewClick($event,0,item.originImage)">
                <image-component :image="item.originImage" :width="150" :height="150" :compress="1.2"></image-component>
              </td>
              <td class="lightgallery" @click="onImagePreviewClick($event,0,item.subImage)">
                <image-component :image="item.subImage"  :width="150" :height="150" :compress="1.2"></image-component>
              </td>
              <td class="lightgallery" @click="onImagePreviewClick($event,0,item.image)">
                <a :href="item.link">
                  <p>{{item.name}}</p>
                </a>
                <image-component :image="item.image" :width="150" :height="150" :compress="1.2"></image-component>
              </td>
              <td>{{item.createTime}}</td>
              <td>{{item.updateTime}}</td>
              <td>{{item.stock}}</td>
              <td>{{item.category}}</td>
              <td>
                <p class="price">￥{{item.price}}</p>
                <p class="origin-price">￥{{item.originPrice}}</p>
              </td>
              <td>
                <span>前端状态：</span>
                <span v-if="item.showStatus==0">未开放</span>
                <span v-if="item.showStatus==1">已开放</span><br/>
                <span>入库状态：</span>
                <span v-if="item.thirdStatus == 0">未入库</span>
                <span v-if="item.thirdStatus == 4">已入库</span>
                <span v-if="item.thirdStatus == 1 || item.thirdStatus == 2 || item.thirdStatus == 3">待审核</span>
              </td>
              <td>{{item.clickCount}}</td>
              <td>
                <button v-if="item.showStatus == 0" class="button is-primary" @click="onChangeStatus(1,index)">开放</button>
                <button class="button is-warning" v-else @click="onChangeStatus(0,index)">撤回</button>
                <button class="button is-danger" @click="onChangeStatus(2,index)">删除</button>
                <button v-if="item.thirdStatus == 0&&item.pplatform!==0" class="button is-info" @click="goRouter(item,index)">入库</button>
                <el-button v-if="item.thirdStatus == 1&&item.pplatform!==0" type="primary" :loading="true" size="small">抓取中</el-button>
                <button v-if="item.thirdStatus == 2&&item.pplatform!==0" class="button is-info"  @click="goRouter(item)" >审核</button>
                <el-button v-if="item.thirdStatus == 3&&item.pplatform!==0" type="danger"  size="small">抓取失败</el-button>
                <button v-if="item.thirdStatus == 4&&item.pplatform!==0" class="button is-info" @click="goRouter(item)">编辑</button>
              </td>
            </tr>
            </tbody>
          </table>
          <el-pagination
            v-if="count > 0"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-size="search.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="count"
            class="fright">
          </el-pagination>
        </article>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { getTimeByDateStr } from 'UTILS/date'
  import {onImagePreviewClick} from 'UTILS/imagePreview'


  export default {
    data(){
      return {
        search:{
          page: 1,
          pageSize: 10,
          status: ['0'],
          startTime: '',
          endTime: '',
          startPrice:null,
          endPrice:null,
          showStatus:-1,
          thirdStatus:-1,
          sortByClickCount:0,
          thirdPartyGoodsId:null,
          articleId:null,
        },
        list:[],
        isCheckAll:false,
        count: 0,
        todayData: {
          todayGoodsCatched: 0,
          todayGoodsOnline: 0,
          goodsCatched: 0,
          goodsOnline: 0,
        },
        sort:{
            sortType:0,
            class:{
                'fa-sort':true,
                'fa-sort-desc':false,
                'fa-sort-asc':false
            }
        },
        initThirdStatus:[
            {
                id:-1,
                name:'全部'
            },
            {
                id:0,
                name:'未入库'
            },
            {
                id:1,
                name:'待审核'
            },
            {
                id:2,
                name:'已入库'
            },

        ],
        initShowStatus:[
            {
                id:-1,
                name:'全部'
            },
            {
                id:0,
                name:'未开放'
            },
            {
                id:1,
                name:'已开放'
            }
        ],
        tempFlag:true,
        tempFlagIndex:null,
        timer:null,
      }
    },
    mounted(){
      this.getList();
    },
    methods: {
        timerPolling(thirdPartyGoodsId,platform,index){
            this.timer = setInterval(()=>{
                this.getGood(thirdPartyGoodsId,platform,index);
            }, 10000);
        },
      goRouter(item,index){
          let platform = '';
          if(item.link.indexOf('taobao') > -1){
              platform = '1';
          }else if(item.link.indexOf('tmall') > -1){
              platform = '2';
          }else if(item.link.indexOf('mogujie') > -1){
              platform = '3';
          }
          if(item.thirdStatus==0){
              let params={
                  thirdPartyGoodsId:item.goodsId,
                  platform:platform,
                  isCloseWindow:0
              }
              HttpRequest.post('/admin.php?method=shoppingguide.doAddGoods',params).then(response => {
                  if(response.data.result){
                      this.$message("操作成功!")
                      this.list[index].thirdStatus=1;
                      clearInterval(this.timer);
                      this.timerPolling(params.thirdPartyGoodsId,params.platform,index);
                  }
              })
          }
          if(item.thirdStatus==2){
              window.open('/adminv/#!/thirdGoods/addGoods?hasMultiPrice=0&platform='+platform+'&thirdPartyGoodsId='+item.goodsId)
          }
          if(item.thirdStatus==4){
              window.open('/adminv/#!/thirdGoods/addGoods?goodsId='+item.outerGoodsId)
          }
      },
      onSort(){
          if(this.sort.sortType == 1){
              this.sort.sortType = 2;
              this.sort.class['fa-sort'] = false;
              this.sort.class['fa-sort-desc'] = true;
              this.sort.class['fa-sort-asc'] = false;
          }else{
              this.sort.sortType = 1;
              this.sort.class['fa-sort'] = false;
              this.sort.class['fa-sort-desc'] = false;
              this.sort.class['fa-sort-asc'] = true;
          }
          this.search.sortByClickCount = this.sort.sortType;
          this.getList(this.search);
      },
      handleCurrentChange(page) {
        if (this.search.page != page) {
          this.search.page = page
          this.getList()
        }
      },
      doSearch() {
        this.search.page = 1
        this.getList()
      },
      getGood(thirdPartyGoodsId,platform,index){
          let params={
              thirdPartyGoodsId:thirdPartyGoodsId,
              platform:platform
          }
          HttpRequest.get('/admin.php?method=fashion.getGoodsFetchStatus', params).then(response => {
            if(response.data.thirdStatus!==1){
                console.log("清除定时器");
                clearInterval(this.timer);
                this.list[index].thirdStatus=response.data.thirdStatus;
            }
          })
       },
      getList(){
          if(this.search.thirdStatus==-1){
              this.search.thirdStatus=null;
          }
          if(this.search.showStatus==-1){
              this.search.showStatus=null;
          }
        let params = Object.assign({}, this.search, {startTime: getTimeByDateStr(this.search.startTime), endTime: getTimeByDateStr(this.search.endTime), allInfo: 1})
        HttpRequest.get('/admin.php?method=fashion.getSimilaryGoods', params).then(response => {
          _.each(response.data.list,item => {
          	item.checked = false
          })
          this.todayData = response.data.todayData ? response.data.todayData : this.todayData
          this.list = _.toArray(response.data.list)
          this.count = response.data.count ? response.data.count : 0
          this.list.forEach((item,index) => {
              if(item.thirdStatus==1){
                  clearInterval(this.timer);
                  this.timerPolling(item.thirdPartyGoodsId,item.platform,index);
              }
          })
        })
      },
      onChangeStatus(actionType,index){
        let params = {}
        if(typeof index !== "undefined"){//单个操作
          params = {
            actionType:actionType,
            ids:[this.list[index].id]
          }
        }else {//批量操作
          let temp = []
          this.list.forEach(item => {
            if(item.checked){
              temp.push(item.id)
            }
          })
          if(!temp.length){
            this.$message("当前没有可以操作的项")
            return false
          }
          params = {
            actionType:actionType,
            ids:temp
          }
        }
        this.operateSimilaryGoods(params,index)
      },
      operateSimilaryGoods(params,index){
        HttpRequest.post('/admin.php?method=fashion.operateSimilaryGoods',params).then(response => {
          if(response.data.success){
            if(typeof index !== "undefined"){
                this.$message("操作成功!")
                this.list[index].showStatus=this.list[index].showStatus===0?1:0;
            }else{
                this.$message("操作成功!")
                this.getList()
            }
          }
        })
      },
      onImagePreviewClick:onImagePreviewClick,
        onCheckAll(){
        setTimeout(()=>{
        	if(this.isCheckAll){
        		_.each(this.list,item => {
        			item.checked = true
            })
          }else {
            _.each(this.list,item => {
              item.checked = false
            })
          }
        },0)
      },
      onCheckOne(index){
        setTimeout(()=>{
        	if(!this.list[index].checked){
        		this.isCheckAll = false
            return false
          }
          for(let i = 0, len = this.list.length; i < len; i++){
        		if(!this.list[i].checked){
              this.isCheckAll = false
              return false
            }
          }
          this.isCheckAll = true
        },0)
      }
    }
  }
</script>
<style lang="less" scoped>
  .similary-goods {
    .price {
      color: red;
    }
    .origin-price {
      color:#ccc;
      text-decoration: line-through;
    }
  .margin-left{
    margin-left: 50px;
  }
    .margin-right{
      margin-right: 30px;
    }
  }
  .data-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 400px;
    .data-item {
      width:50%;
      margin-top: 20px;
    }
  }
</style>
